"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TrelloPowerUpContextProvider = exports.TrelloPowerUpContext = exports.checkAuth = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var posthog_js_1 = __importDefault(require("posthog-js"));
var iframe_1 = require("../iframe");
var SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';
var isIframeConnectorPath = ['iframe-connector', 'iframeconnector'].some(function (path) { return window.location.pathname.toLowerCase().includes(path); });
posthog_js_1["default"].init('phc_nqDlWg081h0LcwCNy4XV02fFt827PvHjcOwa5YQPRgw', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: !isIframeConnectorPath,
    capture_pageleave: !isIframeConnectorPath,
    autocapture: !isIframeConnectorPath
});
var checkAuth = function (token, powerUp) { return __awaiter(void 0, void 0, void 0, function () {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch("".concat(SERVER_URL, "/check-auth"), {
                        method: 'post',
                        body: JSON.stringify({ token: token, powerUp: powerUp }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })];
            case 1:
                response = _a.sent();
                if (response.ok) {
                    return [2 /*return*/, true];
                }
                else {
                    return [2 /*return*/, false];
                }
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.checkAuth = checkAuth;
var noop = function () {
    throw new Error('Not Implemented.');
};
exports.TrelloPowerUpContext = (0, react_1.createContext)({
    isLoading: true,
    members: [],
    isAuthorized: false,
    isAuthorizing: false,
    authorize: noop,
    powerUpKey: '',
    token: '',
    appName: '',
    appKey: ''
});
var TrelloPowerUpContextProvider = function (_a) {
    var appKey = _a.appKey, appName = _a.appName, powerUpKey = _a.powerUpKey, localization = _a.localization, children = _a.children;
    var trelloIframe = (0, iframe_1.useTrelloIframe)({ appKey: appKey, appName: appName, localization: localization });
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(), me = _c[0], setMe = _c[1];
    var _d = (0, react_1.useState)([]), members = _d[0], setMembers = _d[1];
    var _e = (0, react_1.useState)(), board = _e[0], setBoard = _e[1];
    var _f = (0, react_1.useState)(), org = _f[0], setOrg = _f[1];
    var _g = (0, react_1.useState)(false), isAuthorized = _g[0], setIsAuthorized = _g[1];
    var _h = (0, react_1.useState)(false), isAuthorizing = _h[0], setIsAuthorizing = _h[1];
    var _j = (0, react_1.useState)(null), authError = _j[0], setAuthError = _j[1];
    var _k = (0, react_1.useState)(), token = _k[0], setToken = _k[1];
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _me, _isAuthorized, _board, _org, e_2, _token, authIsValid;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsLoading(true);
                        return [4 /*yield*/, Promise.all([
                                trelloIframe.member('all'),
                                trelloIframe.getRestApi().isAuthorized(),
                                trelloIframe.board('all'),
                            ])];
                    case 1:
                        _a = _b.sent(), _me = _a[0], _isAuthorized = _a[1], _board = _a[2];
                        if (_me) {
                            posthog_js_1["default"].identify(_me.id, {
                                name: _me.fullName || _me.username,
                                email: _me.email
                            });
                        }
                        setMe(_me);
                        setMembers(_board.members);
                        setBoard(_board);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, trelloIframe.organization('all')];
                    case 3:
                        _org = _b.sent();
                        setOrg(_org);
                        return [3 /*break*/, 5];
                    case 4:
                        e_2 = _b.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        if (!_isAuthorized) return [3 /*break*/, 10];
                        return [4 /*yield*/, trelloIframe.getRestApi().getToken()];
                    case 6:
                        _token = _b.sent();
                        return [4 /*yield*/, (0, exports.checkAuth)(_token, powerUpKey)];
                    case 7:
                        authIsValid = _b.sent();
                        if (!authIsValid) return [3 /*break*/, 8];
                        setToken(_token);
                        setIsAuthorized(_isAuthorized);
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, trelloIframe.getRestApi().clearToken()];
                    case 9:
                        _b.sent();
                        setIsAuthorized(false);
                        _b.label = 10;
                    case 10: return [4 /*yield*/, window.TrelloPowerUp.util.initLocalizer(window.locale, {
                            localization: localization
                        })];
                    case 11:
                        _b.sent();
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    var authorize = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _token, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    setIsAuthorizing(true);
                    setAuthError(null);
                    return [4 /*yield*/, trelloIframe
                            .getRestApi()
                            .authorize({ scope: 'read,write,account' })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, trelloIframe.getRestApi().getToken()];
                case 2:
                    _token = _a.sent();
                    setToken(_token);
                    setIsAuthorized(true);
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _a.sent();
                    setIsAuthorized(false);
                    setAuthError(e_3);
                    return [3 /*break*/, 4];
                case 4:
                    setIsAuthorizing(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    return ((0, jsx_runtime_1.jsx)(exports.TrelloPowerUpContext.Provider, __assign({ value: {
            isLoading: isLoading,
            me: me,
            members: members,
            board: board,
            org: org,
            isAuthorized: isAuthorized,
            isAuthorizing: isAuthorizing,
            authorize: authorize,
            authError: authError,
            token: token,
            powerUpKey: powerUpKey,
            trelloIframe: trelloIframe,
            appName: appName,
            appKey: appKey
        } }, { children: children }), void 0));
};
exports.TrelloPowerUpContextProvider = TrelloPowerUpContextProvider;
//# sourceMappingURL=TrelloPowerUpContext.js.map